import {useState} from "react";
import {v4 as uuidv4} from "uuid";

const useLoading = () => {
    const [loading, setLoading] = useState([])
    const startLoading = () => {
        const id = uuidv4()
        setLoading(prevState => prevState.concat([id]))
        return () => setLoading(prevState => prevState.filter(currentId => currentId !== id))
    }
    const isLoading = !!loading.length
    return [isLoading, startLoading]
}
export default useLoading;